import { Club } from '@/model';
import {
  GetTeamClubByIdResponse,
  GetTeamClubItemResponse,
  GetTeamClubResponse,
  PostTeamClubResponse,
  PutTeamClubResponse,
} from '@/services/response/club';

export class ClubConverter {
  static toDomainFromGetItemResponse(response: GetTeamClubItemResponse): Club {
    return {
      uuid: response.uuid,
      name: response.name,
      favorite: response.favorite,
      acronym: response.acronym,
      logo_path: response.logo_path,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPaginatedResponse(response: GetTeamClubResponse): Club[] {
    return response.data.map(ClubConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromPostResponse(response: PostTeamClubResponse): Club {
    return {
      uuid: response.uuid,
      name: response.name,
            favorite: response.favorite,

      acronym: response.acronym,
      logo_path: response.logo_path,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromByIdResponse(response: GetTeamClubByIdResponse): Club {
    return {
      uuid: response.uuid,
      name: response.name,
            favorite: response.favorite,

      acronym: response.acronym,
      logo_path: response.logo_path,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutResponse(response: PutTeamClubResponse): Club {
    return {
      uuid: response.uuid,
      name: response.name,
      acronym: response.acronym,
            favorite: response.favorite,

      logo_path: response.logo_path,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
